import * as React from "react";
import { toast } from "@grandvisionhq/common";
import { Util } from "@grandvisionhq/forms";
import { useDispatch, useSelector } from "@grandvisionhq/state";
import { shouldCreateAccount } from "../../../../selectors.js";
import { markFieldsTouched, setMyAccountValidation, setServiceStoreValidation } from "../../../StepShipping/actions.js";
import { useCheckoutSettings } from "../../../../context/CheckoutSettings/context/CheckoutSettings/context.js";
const useInvalidShippingStep = () => {
  const checkoutSettings = useCheckoutSettings();
  const dispatch = useDispatch();
  const isCreateAccountRequired = Boolean(
    checkoutSettings.account?.implicitAccountCreation || checkoutSettings.account?.createAccountRequired
  );
  const shouldCreateAccountBoolean = useSelector(shouldCreateAccount);
  const isServiceStoreEnabled = checkoutSettings.features?.isServiceStoreEnabled;
  const handleInvalidStepShipping = React.useCallback(() => {
    dispatch(markFieldsTouched());
    if (isCreateAccountRequired && !shouldCreateAccountBoolean) {
      dispatch(setMyAccountValidation());
    }
    if (isServiceStoreEnabled && !checkoutSettings.serviceStore?.isOptional) {
      dispatch(setServiceStoreValidation());
    }
    toast.failed("checkout.errors.form.general");
    Util.focusToTopErrorFieldOnScreen();
  }, [
    checkoutSettings.serviceStore?.isOptional,
    dispatch,
    isCreateAccountRequired,
    isServiceStoreEnabled,
    shouldCreateAccountBoolean
  ]);
  return {
    handleInvalidStepShipping
  };
};
export {
  useInvalidShippingStep
};
//# sourceMappingURL=use-invalid-shipping-step.js.map
